import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ensure SPA route changes start at the top so users can tell navigation worked.
 * Keeps anchor/hash navigation behavior intact.
 */
export default function ScrollToTopOnRouteChange() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, hash]);

  return null;
}
